// extracted by css-extract-rspack-plugin
export default {"label":"HaRfY5s9AHogBvmr"};